/**
 * Paneles laterales de la PDP (snippets/pdp-drawer.liquid).
 *
 * Convierte dos acordeones —"Tabla Nutrimental" y "¿Cómo se toma?"— en disparadores de
 * un panel que entra desde la derecha, conservando intacto el aspecto de acordeón.
 *
 * Tres decisiones que NO son de estilo y conviene no deshacer:
 *
 * 1. EL PANEL SE MUEVE A <body>. Nace dentro del `.accordion__content`, que cuelga de
 *    `product-info`, que lleva `data-aos`. AOS deja un `transform` permanente en el
 *    elemento y un `transform` convierte al elemento en bloque contenedor de sus
 *    descendientes `position: fixed`: el overlay se recortaría a la columna de la buy box
 *    en vez de cubrir la ventana.
 *
 * 2. EL CLIC SE INTERCEPTA EN FASE DE CAPTURA SOBRE `document`. `CollapsibleRow`
 *    (assets/global.js:1620) ya registra su propio listener de clic en el `summary` en su
 *    `connectedCallback`, y hace `preventDefault()` para animar la apertura él mismo. Un
 *    listener nuestro en el mismo `summary` correría DESPUÉS del suyo y la animación de
 *    despliegue ya se habría lanzado. En captura sobre `document` corremos antes que
 *    cualquier listener de cualquier descendiente, y `stopPropagation()` lo deja fuera.
 *    De paso, al ser delegado sobrevive a los re-renders de `product-info` al cambiar de
 *    variante, que rehacen el markup de los acordeones.
 *
 * 3. EL REGISTRO ES UN MAPA, NO `getElementById`. Tras un re-render conviven el panel
 *    viejo (ya colgado de <body>, al final del documento) y el nuevo (todavía dentro de
 *    la sección, antes en orden de documento). `getElementById` devolvería el nuevo y el
 *    viejo se quedaría acumulándose en el DOM.
 */
(function () {
  'use strict';

  if (window.pdpDrawerReady) return;
  window.pdpDrawerReady = true;

  var SELECTOR = '[data-pdp-drawer]';
  var CLOSE_DELAY = 320; // Debe superar la transición de .pdp-drawer__panel en pdp-figma.css.

  var registry = Object.create(null);
  var lastTrigger = null;
  var scanQueued = false;

  function adopt(drawer) {
    var details = drawer.closest('details');
    if (details) details.setAttribute('data-pdp-drawer-target', drawer.id);

    var previous = registry[drawer.id];
    if (previous && previous !== drawer && previous.parentNode) {
      previous.parentNode.removeChild(previous);
    }
    registry[drawer.id] = drawer;
    document.body.appendChild(drawer);
  }

  function scan() {
    scanQueued = false;
    var drawers = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < drawers.length; i++) {
      // Ya adoptado: nada que hacer. Este early-return es lo que impide que el
      // MutationObserver de abajo se realimente con su propio appendChild.
      if (drawers[i].parentElement === document.body) continue;
      adopt(drawers[i]);
    }
  }

  function queueScan() {
    if (scanQueued) return;
    scanQueued = true;
    window.requestAnimationFrame(scan);
  }

  function open(drawer, trigger) {
    lastTrigger = trigger || null;
    drawer.removeAttribute('hidden');
    // Lectura forzada de layout: sin ella el navegador agrupa el cambio de `hidden` con
    // el de clase y la transición de entrada no llega a correr.
    drawer.getBoundingClientRect();
    drawer.classList.add('is-open');
    document.body.classList.add('pdp-drawer-open');

    var closeButton = drawer.querySelector('.pdp-drawer__close');
    if (closeButton) closeButton.focus();
  }

  function close(drawer) {
    drawer.classList.remove('is-open');
    document.body.classList.remove('pdp-drawer-open');

    window.setTimeout(function () {
      // Puede haberse reabierto durante la espera; en ese caso no lo escondemos.
      if (!drawer.classList.contains('is-open')) drawer.setAttribute('hidden', '');
    }, CLOSE_DELAY);

    if (lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || typeof target.closest !== 'function') return;

      var closer = target.closest('[data-pdp-drawer-close]');
      if (closer) {
        var openDrawer = closer.closest(SELECTOR);
        if (openDrawer) {
          event.preventDefault();
          close(openDrawer);
        }
        return;
      }

      var summary = target.closest('summary');
      if (!summary) return;

      var details = summary.closest('details');
      if (!details) return;

      var drawerId = details.getAttribute('data-pdp-drawer-target');
      if (!drawerId) return;

      var drawer = registry[drawerId];
      if (!drawer) return;

      event.preventDefault();
      event.stopPropagation();
      open(drawer, summary);
    },
    true
  );

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' && event.key !== 'Esc') return;
    var openDrawer = document.querySelector(SELECTOR + '.is-open');
    if (openDrawer) close(openDrawer);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }

  // `product-info` se rehace al cambiar de variante y vuelve a traer los paneles dentro
  // de la sección. Sin esto, el disparador quedaría apuntando a un panel huérfano.
  if (window.MutationObserver) {
    new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes.length) {
          queueScan();
          return;
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
